import { bindable, IEventAggregator, ILogger, resolve } from 'aurelia';

export class RoomTypePriceSelection {

    // properties for view component
    @bindable hotel;
    // generate unique id for html elements
    @bindable uniqueId;

    rooms = [];

    aurelia_options = aurelia_options;
    RESOURCE_BASE_URL = aurelia_options.resourceBaseUrl;
    eventAggregator = resolve(IEventAggregator);
    log = resolve(ILogger).scopeTo('app.RoomTypePriceSelection');

    constructor() {
        this.eventId = null;
        this.filterMainDivId = null;

        this.displayLabel = "";
        this.selectedRoomTypeId = "";
        this.selectedRoomTypeMealplanSort = "";
    }
    
    binding() {
        this.rooms = this.hotel.rooms;
        // first item on list is cheapest and is our initial selection
        this.selectedRoomTypeId = this.rooms[0].id;
        this.selectedRoomTypeMealplanSort = this.rooms[0].mealplans[0].sort;
        this.displayLabel = this.rooms[0].name;
    }

    attached() {
        // generate eventAggregator eventId
        this.eventId = 'update-filter-' + this.uniqueId;
        this.filterMainDivId = 'e4-detailfilter-roomtype-' + this.uniqueId;
        // register listener 
        this.updateFilterSubscription = this.eventAggregator.subscribe(this.eventId, params => this.updateFilterEvent(params));

    }

    detached() {
        this.updateFilterSubscription.dispose();
    }

    updateFilterEvent(params) {
        if (params.sender == 'mealplan-selection') {
            this.selectedRoomTypeMealplanSort = params.mealplan.sort;
        }
    }

    // is the currently selected mealplan available in new room
    doesRoomHaveSameSelectedMeal(room) {
        let selectedHotelRoom = this.rooms.find(r => r.id === this.selectedRoomTypeId);
        if (selectedHotelRoom === undefined) {
            this.log.error('No room selected!', JSON.parse(JSON.stringify(this)));
            return false;
        }
        
        let roomMealplan = room.mealplans.find(mp => mp.sort === this.selectedRoomTypeMealplanSort);
        return roomMealplan !== undefined;
    }

    calculateRoomPrice(room, index) {
        let selectedHotelRoom = this.rooms.find(r => r.id === this.selectedRoomTypeId);
        if (selectedHotelRoom === undefined) {
            this.log.error('No room selected! Cannot calculate price!', JSON.parse(JSON.stringify(this)));
            return;
        }
        
        // btw, currently selected mealplan might not be available in new roomdesc!!
        let roomMealplan = room.mealplans.find(mp => mp.sort === this.selectedRoomTypeMealplanSort);
        let selectedRoomMealplan = selectedHotelRoom.mealplans.find(mp => mp.sort === this.selectedRoomTypeMealplanSort);
        if (roomMealplan !== undefined) {
            return roomMealplan.price - selectedRoomMealplan.price;
        }

        
        // mealplan from current selection is not available. select cheapest price there is for this specific room
        let cheapestRoom = room.mealplans
            .reduce((lowest, item) => {
                return (item.price < lowest.price) ? item : lowest;
            });
        let result = cheapestRoom.price - selectedRoomMealplan.price;
        return result;
    }

    //open-close filter details
    openCloseFilter() {
        this.setFilterVisible(! document.querySelector('#' + this.filterMainDivId).open);
    }

    setFilterVisible(show) {
        if (show) {
            document.querySelector('#' + this.filterMainDivId).show();
        } else {
            document.querySelector('#' + this.filterMainDivId).close();
        }
    }

    closeFilterWithDelay(index) {
        // new value was selected
        
        if (this.selectedRoomTypeId != this.rooms[index].id) {

            this.selectedRoomTypeId = this.rooms[index].id
            this.hotel.selected_room_id = this.rooms[index].id;
            this.displayLabel = this.rooms[index].name

            this.log.debug('index: ', index);
            this.log.debug('rooms: ', this.rooms);

            let newMealplan = this.rooms[index].mealplans.find(mp => mp.sort === this.selectedRoomTypeMealplanSort);
            if (newMealplan === undefined) {
                newMealplan = this.rooms[index].mealplans[0];
            }
            this.selectedRoomTypeMealplanSort = newMealplan.sort;

            // broadcast, that new roomtype was selected
            this.eventAggregator.publish(this.eventId,
                {
                    sender: 'room-type-selection',
                    room: this.rooms[index],
                    mealplan: newMealplan
                }
            );

        }

        setTimeout(() => {
            this.setFilterVisible(false);
        }, 400);
        return true;
    }

}
